export const GET_SEARCH_RESULTS: string = "GET_SEARCH_RESULTS";
export const SET_SEARCH_KEYWORD: string = "SET_SEARCH_KEYWORD";
